import React, { useState } from "react";
import { useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import Button from "react-bootstrap/Button";
import Modal from "common/modal";
import { api } from "store/slices/api";
import { toast } from "react-toastify";

const RefreshPricesModal = () => {
  const dispatch = useDispatch();
  const { quoteId } = useParams();
  const { sub, terrCcn, storeCcn } = useSelector((state) => state.loggedInUser);
  const { data: quote = {} } = api.useGetPriceQuoteQuery(quoteId);
  const [editQuote] = api.useDeprecatedEditQuoteMutation();
  const [show, setShow] = useState(false);

  const { jobNumber, prcNumber, territory, storeNumber } = quote;

  const refreshPrices = () => {
    var editPayload = {
      userName: sub,
      quoteId,
      quoteName: quote.quoteName ?? "",
      territory: territory ?? "",
      expirationDate: quote.expirationDate ?? "",
      salesRep: quote.salesRep ?? "",
      accountNumber: quote.accountNumber ?? "",
      accountName: quote.accountName ?? "",
      contactName: quote.contactName ?? "",
      phoneNumber: quote.phone ?? "",
      customerName: quote.customerName ?? "",
      storeNumber: storeNumber ?? "",
      storeName: quote.storeName ?? "",
      storePhoneNumber: quote.storePhoneNumber ?? "",
      parentNumber: quote.parentNumber ?? "",
      parentName: quote.parentName ?? "",
      execName: quote.execName ?? "",
      execNumber: quote.execNumber ?? "",
      taxRate: quote.taxRate ?? "0.00",
      city: quote.city ?? "",
      street: quote.street ?? "",
      zip: quote.zip ?? "",
      state: quote.state ?? "",
      jobNumber: jobNumber ?? "",
      jobName: quote.jobName ?? "",
      prcNumber: prcNumber ?? "",
      prcDesc: quote.prcDesc ?? "",
      isTaxEdited: false,
      isPrcEdited: true,
      isStoreAccChanged: false,
    };

    setShow(false);
    toast.promise(editQuote(editPayload).unwrap(), {
      success: "Prices refreshed",
      pending: "Refreshing prices",
      failure: "Something went wrong",
    });
  };

  return (
    <>
      {jobNumber && prcNumber && ((territory === terrCcn && territory !== "800100") || storeCcn === storeNumber) && (
        <Button variant="outline-primary" onClick={() => setShow(true)}>
          Refresh Prices
        </Button>
      )}
      {show && (
        <Modal
          title="Refresh Prices"
          handleSave={refreshPrices}
          handleCancel={() => setShow(false)}
          size="lg"
          sectionName=""
          closeButtonText="Cancel"
          saveButtonText="Continue"
        >
          <div className="container-fluid p-2 border-0 m-0">
            <p>
              Refreshing prices from PRC will replace all prices currently on the quote. Are you sure you want to
              refresh prices?
            </p>
          </div>
        </Modal>
      )}
    </>
  );
};

export default RefreshPricesModal;
